const _version = "2.13.1"
function version() {
    return _version
}
export default version
